import { saveAs } from 'file-saver'

/**
 * Fetch a signed URL's content as a blob. No auth header — the signature in the URL is the
 * authorization (matching how `download-matter-artifact-docx.ts` treats direct blob fetches).
 * Aborting the optional signal rejects the fetch with an AbortError.
 */
export async function fetchSignedUrlBlob(downloadUrl: string, signal?: AbortSignal): Promise<Blob> {
  const response = await fetch(downloadUrl, { signal })
  if (!response.ok) throw new Error(`Failed to fetch signed download URL. Status: ${response.status}`)
  return response.blob()
}

/**
 * Save an already-fetched blob as a local file. Separate from the fetch so callers can re-check
 * attempt validity (e.g. after a cancel) between fetching and delivering the file.
 */
export function saveBlobAsFile(blob: Blob, filename: string): void {
  saveAs(blob, filename)
}
